import { useEffect, useState } from "react";
import Dropdown from "../../component/dropdown/Dropdown";
import { RequiredLabel } from "../../component/requiredLabel/RequiredLabel";
import TextInput from "../../component/textInput/TextInput";
import {
  PrimaryButton,
  SecondaryButton,
} from "../../component/buttonComponent/ButtonComponent";
import ServiceAnnouncementPreview from "./ServiceAnnouncementPreview";

const iconOptions = [
  { label: "Alert", value: "alert" },
  { label: "Check Mark", value: "checkMark" },
  { label: "Arrow", value: "arrow" },
  { label: "Clock", value: "clock" },
  { label: "Info", value: "info" },
  { label: "Star", value: "star" },
];

const colorOptions = [
  { label: "Green", value: "#099250" },
  { label: "Yellow", value: "#FABE00" },
  { label: "Red", value: "#B42318" },
  { label: "Blue", value: "#175CD3" },
];

const isEmpty = (v) => !v || v.trim() === "";

export const ServiceAnnouncementForm = ({
  mode,
  existingData,
  onSubmit,
  handleReset,
  loading,
  input,
  setInput,
  error,
  setError,
}) => {
  const [isSubmitDisabled, setIsSubmitDisabled] = useState(true);
  const [initialInput, setInitialInput] = useState(true);
  const [keyUp, setKeyUp] = useState("", false);

  const isServiceAnnouncementValid = () => {
    if (!input) return false;

    const isValid =
      input.title.trim() !== "" &&
      input.icon.trim() !== "" &&
      input.titleColor.trim() !== "" &&
      input.content.trim() !== "" &&
      input.content.length <= 1200;

    const isEdited =
      initialInput && JSON.stringify(initialInput) !== JSON.stringify(input);

    return isValid && isEdited;
  };

  useEffect(() => {
    setError({
      title: input.title !== "" ? isEmpty(input.title) : false,
      icon: input.icon !== "" ? isEmpty(input.icon) : false,
      titleColor: input.titleColor !== "" ? isEmpty(input.titleColor) : false,
      content: input.content !== "" ? input.content.length > 1200 : false,
    });
  }, [input]);

  useEffect(() => {
    setIsSubmitDisabled(!isServiceAnnouncementValid());
  }, [input, initialInput]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    const updatedInput = { ...input, [name]: value };
    setInput(updatedInput);
  };

  useEffect(() => {
    if ((mode === "edit" || mode === "view") && existingData) {
      const { _id, institutionId, createdAt, updatedAt, ...rest } =
        existingData;

      setInitialInput(rest);
      setInput(rest);
    } else {
      setInitialInput(input);
    }
  }, [mode, existingData]);

  const inputWidth = "100%";

  return (
    <>
      <div className="trip-type-name-form-container">
        <div className="input-label">
          <RequiredLabel>Announcement Icon</RequiredLabel>
          <div className="input-description">
            Choose the icon shown in the service announcement.
          </div>
        </div>
        <div className="input-container">
          <Dropdown
            disabled={mode === "view"}
            options={iconOptions}
            name="icon"
            placeholder="Select an icon..."
            onChangeFunction={handleInputChange}
            input={input}
            width={inputWidth}
          />
        </div>
      </div>
      <div className="name-form-container">
        <div className="input-label">
          <RequiredLabel>Announcement Title</RequiredLabel>
          <div className="input-description">
            Enter the title of your service announcement.
          </div>
        </div>
        <div className="input-container">
          <TextInput
            placeholder={mode === "view" ? input.title : "Enter Title"}
            setInput={setInput}
            input={mode === "view" ? "" : input}
            name="title"
            disable={mode === "view"}
            type="text"
            error={error.title}
            setError={setError}
            errorMessage=""
            keyUp={keyUp}
            setKeyUp={setKeyUp}
            onChangeFunction={handleInputChange}
            width={inputWidth}
          />
        </div>
      </div>
      <div className="trip-type-name-form-container">
        <div className="input-label">
          <RequiredLabel>Title Colour</RequiredLabel>
          <div className="input-description">
            Choose the colour of the service announcement title.
          </div>
        </div>
        <div className="input-container">
          <Dropdown
            disabled={mode === "view"}
            options={colorOptions}
            name="titleColor"
            placeholder="Select a color..."
            onChangeFunction={handleInputChange}
            input={input}
            width={inputWidth}
          />
        </div>
      </div>
      <div className="name-form-container">
        <div className="input-label">
          <RequiredLabel>Announcement Content</RequiredLabel>
          <div className="input-description">
            Enter a brief description to explain the purpose of the
            announcement.
          </div>
        </div>
        <div className="input-container">
          <TextInput
            placeholder={
              mode === "view"
                ? input.content
                : "Example: No disruptions expected today."
            }
            type="textarea"
            input={mode === "view" ? "" : input}
            setInput={setInput}
            name="content"
            width={inputWidth}
            onChangeFunction={handleInputChange}
            setError={setError}
            error={error.content}
            errorMessage="Content should not exceed 1200 characters"
            keyUp={keyUp}
            setKeyUp={setKeyUp}
            disable={mode === "view"}
            showCharCount
            maxLength={1200}
          />
        </div>
      </div>
      <div className="name-form-container">
        <div className="input-label">
          Preview
          <div className="input-description"></div>
        </div>
        <div className="input-container">
          <ServiceAnnouncementPreview
            icon={input.icon}
            title={input.title}
            titleColor={input.titleColor}
            content={input.content}
          />
        </div>
      </div>
      <div className="button-container-edit">
        <SecondaryButton
          width="6rem"
          label="Cancel"
          imageIcon={false}
          onClickFunction={handleReset}
        />
        {mode !== "view" && (
          <PrimaryButton
            width="6rem"
            disable={isSubmitDisabled}
            label={mode === "create" ? "Create" : "Save"}
            onClickFunction={onSubmit}
            loading={loading}
          />
        )}
      </div>
    </>
  );
};
